// Components
import { MainDiv, Title, GrayText, GrayBoldText, MetricAlignerDiv, MetricDiv, MetricRateValue, Span, MetricRateText } from "./styles";

const RecentTreatmentEfficacy = ({ lastMetric }) => {
  const renderDMMetric = () => {
    const metrics = lastMetric.filter((metric) => Boolean(metric?.delta_dm));
    const isThereSomeMetric = Boolean(metrics.length);

    const metricsSum = metrics.reduce((accumulator, metric) => accumulator + Number(metric.delta_dm), 0);

    const metricValue = isThereSomeMetric ? metricsSum / metrics.length : "-";

    const color = "#000";

    return (
      <MetricDiv border="none" background="rgba(242, 242, 242, 0.95)">
        <MetricRateValue color={color}>
          {metricValue.toString().length > 4 ? metricValue.toString().substring(0, 4) : metricValue}
        </MetricRateValue>
        <MetricRateText color={color}>Difficulty Modulators</MetricRateText>
      </MetricDiv>
    );
  };

  const renderAdherenceMetric = () => {
    const metrics = lastMetric.filter((metric) => Boolean(metric?.recent_adherence));
    const isThereSomeMetric = Boolean(metrics.length);

    const metricsSum = metrics.reduce((accumulator, metric) => accumulator + Number(metric.recent_adherence), 0);

    const metricValue = Math.round((metricsSum / metrics.length) * 100);

    const parsedMetricValue = isThereSomeMetric ? `${metricValue}%` : "-";

    const isLessThan50 = isThereSomeMetric ? metricValue < 50 : false;
    const color = isLessThan50 ? "#F15A24" : "#000";

    return (
      <MetricDiv border={isLessThan50 ? "1px solid #F15A24" : "none"} background={isLessThan50 ? "#efe3de" : "rgba(242, 242, 242, 0.95)"}>
        <MetricRateValue color={color}>
          {parsedMetricValue.toString().length > 4 ? parsedMetricValue.toString().substring(0, 4) : parsedMetricValue}
        </MetricRateValue>
        <MetricRateText color={color}>Adherence</MetricRateText>
      </MetricDiv>
    );
  };

  const renderCompetenceMetric = () => {
    const metrics = lastMetric.filter((metric) => Boolean(metric?.ppf));
    const isThereSomeMetric = Boolean(metrics.length);

    const metricsSum = metrics.reduce((accumulator, metric) => accumulator + Number(metric.ppf), 0);

    const metricValue = isThereSomeMetric ? metricsSum / metrics.length : "-";

    const isLessThan05 = isThereSomeMetric ? metricValue < 0.5 : false;
    const color = isLessThan05 ? "#F15A24" : "#000";

    return (
      <MetricDiv border={isLessThan05 ? "1px solid #F15A24" : "none"} background={isLessThan05 ? "#efe3de" : "rgba(242, 242, 242, 0.95)"}>
        <MetricRateValue color={color}>
          {metricValue.toString().length > 4 ? metricValue.toString().substring(0, 4) : metricValue}
          {isThereSomeMetric && <Span> / 1</Span>}
        </MetricRateValue>
        <MetricRateText color={color}>Competence</MetricRateText>
      </MetricDiv>
    );
  };

  return (
    <MainDiv>
      <Title>Recent Treatment Efficacy Assessment</Title>
      <GrayText>
        The Recommender System tracks and optimizes patient recovery using three key variables, collectively referred to as Treatment
        Efficacy. These metrics help personalize and adjust the treatment path over time.
      </GrayText>
      <div>
        <GrayText>
          <GrayBoldText>• Difficulty Modulators (DM Changes)</GrayBoldText>
        </GrayText>
        <GrayText>
          <GrayBoldText>• Adherence</GrayBoldText> - Scale from 0 to 100
        </GrayText>
        <GrayText>
          <GrayBoldText>• Competence</GrayBoldText> - Scale from 0.0 to . 1.0
        </GrayText>
      </div>
      <MetricAlignerDiv>
        {renderDMMetric()}
        {renderAdherenceMetric()}
        {renderCompetenceMetric()}
      </MetricAlignerDiv>
    </MainDiv>
  );
};

export default RecentTreatmentEfficacy;
